import { SxProps, Theme } from "@mui/material/styles";

export const overlay: SxProps<Theme> = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 999999,
    p: 2,
};

export const bannerContainer: SxProps<Theme> = {
    maxWidth: 600,
    width: "100%",
    borderRadius: 1,
    background: "linear-gradient(135deg, #003d82 0%, #0056b3 100%)",
    border: (theme: Theme) => `2px solid ${theme.palette.hsvBlueDark}`,
};

export const contentContainer: SxProps<Theme> = {
    p: 4,
};

export const title: SxProps<Theme> = {
    color: (theme: Theme) => theme.palette.white,
    fontWeight: "bold",
    mb: 2,
    textAlign: "center",
};

export const description: SxProps<Theme> = {
    color: (theme: Theme) => theme.palette.white,
    lineHeight: 1.6,
    mb: 3,
    textAlign: "left",
};

export const detailsContainer: SxProps<Theme> = {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    borderRadius: 1,
    p: 2,
    mb: 3,
};

export const details: SxProps<Theme> = {
    color: (theme: Theme) => theme.palette.white,
    fontSize: "0.85rem",
    lineHeight: 1.5,
};

export const buttonContainer: SxProps<Theme> = {
    display: "flex",
    gap: 2,
    justifyContent: "center",
    flexWrap: "wrap",
};

export const declineButton: SxProps<Theme> = {
    borderColor: (theme: Theme) => theme.palette.white,
    color: (theme: Theme) => theme.palette.white,
    px: 3,
    py: 1,
    minWidth: 120,
    fontWeight: "600",

    "&:hover": {
        borderColor: (theme: Theme) => theme.palette.white,
        backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
};

export const acceptButton: SxProps<Theme> = {
    backgroundColor: (theme: Theme) => theme.palette.white,
    color: (theme: Theme) => theme.palette.hsvBlueDark,
    px: 3,
    py: 1,
    minWidth: 120,
    fontWeight: "600",

    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.9)",
    },
};
